import Api from '@common/services/api';

export const duplicateComponent = async (
  organisationId: string,
  formId: string,
  componentId: string
) => {
  const { data } = await Api.post(
    `/v1/organisations/${organisationId}/performance/forms/${formId}/components/${componentId}/duplicate`
  );

  return { data };
};
